import React, { Component } from 'react';
import { Segment } from 'semantic-ui-react';

class Header extends Component {
  render() {
    return (
      <Segment textAlign="center" basic className="footer">
        <address>
          Besøksadresse: Hollendergata 5, 0190 Oslo<br /> Postadresse: Postboks
          9354 - Grønland, 0135 Oslo
        </address>{' '}
        <p>
          +47 22 05 46 40 - <a href="mailto:post@hanen.no">post@hanen.no</a>
        </p>
        <h4>
          HANEN -{' '}
          <span>
            næringsorganisasjonen for bygdeturisme, gardsmat og innlandsfiske
          </span>
        </h4>
        <p>
          Innholdet er beskyttet etter Åndsverksloven<br />&copy; 2004 -{' '}
          {new Date().getFullYear()}
          <br />
          <a href="http://hanen.no">HANEN.no</a>
        </p>
      </Segment>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Footer.js